const BUNNY_PLAYBACK_SEGMENT = "/play/";

export const isVideoMedia = (media = {}) => {
  const type = (media?.mediaType || "").toUpperCase();
  const fileUrl = (media?.fileUrl || media?.mediaUrl || media?.url || "").toLowerCase();
  return (
    type === "VIDEO" ||
    fileUrl.endsWith(".mp4") ||
    fileUrl.endsWith(".mov") ||
    fileUrl.endsWith(".webm") ||
    fileUrl.includes("video.bunnycdn.com") ||
    fileUrl.includes("/play/") ||
    fileUrl.includes("mediadelivery.net")
  );
};

export const isImageMedia = (media = {}) =>
  (media?.mediaType || "").toUpperCase() === "IMAGE";

export const isBunnyStreamMedia = (media = {}) => {
  const storageProvider = (media?.storageProvider || "").toUpperCase();
  const resolvedUrl = (getResolvedVideoUrl(media) || "").toLowerCase();
  return (
    storageProvider === "BUNNY_STREAM" ||
    storageProvider === "BUNNY" ||
    resolvedUrl.includes("video.bunnycdn.com") ||
    resolvedUrl.includes(BUNNY_PLAYBACK_SEGMENT) ||
    resolvedUrl.includes("mediadelivery.net") ||
    resolvedUrl.includes(".b-cdn.net")
  );
};

export const BLACK_THUMBNAIL =
  "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23000000'/%3E%3C/svg%3E";

export const getResolvedImageUrl = (media = {}, fallback = "") => {
  if (isVideoMedia(media) || isBunnyStreamMedia(media)) {
    return media?.thumbnailUrl || fallback;
  }
  return media?.fileUrl || media?.thumbnailUrl || media?.mediaUrl || media?.url || fallback;
};

export const getResolvedPosterUrl = (media = {}, fallback = BLACK_THUMBNAIL) => {
  const thumb = media?.thumbnailUrl || "";
  if (
    thumb &&
    !thumb.includes("500b.jpg") &&
    !thumb.toLowerCase().endsWith(".mp4") &&
    !thumb.includes("video.bunnycdn.com") &&
    !thumb.includes("mediadelivery.net")
  ) {
    return thumb;
  }

  const fileUrl = media?.fileUrl || media?.mediaUrl || media?.url || "";
  if (
    fileUrl &&
    !isVideoMedia(media) &&
    !isBunnyStreamMedia(media) &&
    !fileUrl.toLowerCase().endsWith(".mp4") &&
    !fileUrl.includes("video.bunnycdn.com") &&
    !fileUrl.includes("mediadelivery.net")
  ) {
    return fileUrl;
  }

  return fallback || BLACK_THUMBNAIL;
};

export const getResolvedVideoUrl = (media = {}) =>
  media?.playbackUrl || media?.fileUrl || media?.mediaUrl || media?.url || "";

export const getBunnyEmbedUrl = (
  playbackUrl = "",
  { autoplay = false, loop = false, muted = false } = {}
) => {
  try {
    const url = new URL(playbackUrl);
    const [, playSegment, libraryId, videoGuid] = url.pathname.split("/");
    if (playSegment !== "play" || !libraryId || !videoGuid) {
      return playbackUrl;
    }
    const params = new URLSearchParams();
    if (autoplay) params.set("autoplay", "true");
    if (loop) params.set("loop", "true");
    if (muted) params.set("muted", "true");
    const queryString = params.toString();
    return `https://iframe.mediadelivery.net/embed/${libraryId}/${videoGuid}${
      queryString ? `?${queryString}` : ""
    }`;
  } catch (error) {
    return playbackUrl;
  }
};
